import React from 'react';
import './Gallery.css';
import productImage1 from '../assets/IMG_0860.JPG';
import productImage2 from '../assets/IMG_0866.JPG';
import productImage3 from '../assets/IMG_0893.JPG';
import productImage4 from '../assets/IMG_2332.jpg';
import productImage5 from '../assets/IMG_2345.jpg';
import productImage6 from '../assets/IMG_2598.jpg';
import productImage7 from '../assets/IMG_4024.jpg';
import productImage8 from '../assets/IMG_4371.jpg';
import productImage9 from '../assets/IMG_4372.jpg';
import productImage10 from '../assets/IMG_4481.jpg';
import productImage11 from '../assets/IMG_4482.jpg';
import productImage12 from '../assets/IMG_4489.jpg';
import productImage13 from '../assets/IMG_4490.jpg';
import productImage14 from '../assets/IMG_4705.jpg';
import productImage15 from '../assets/IMG_4950.jpg';
import productImage16 from '../assets/IMG_7033.jpg';
import productImage17 from '../assets/IMG_7040.jpg';
import productImage18 from '../assets/IMG_7043.jpg';
import productImage19 from '../assets/IMG_7044.jpg';
import productImage20 from '../assets/IMG_7230.PNG';


const Gallery = () => {
  const images = [
    productImage1,
    productImage2,
    productImage3,
    productImage4,
    productImage5,
    productImage6,
    productImage7,
    productImage8,
    productImage9,
    productImage10,
    productImage11,
    productImage12,
    productImage13,
    productImage14,
    productImage15,
    productImage16,
    productImage17,
    productImage18,
    productImage19,
    productImage20
  ];

  return (
    <div className="gallery-section">
      <h2>Gallery</h2>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div className="gallery-item" key={index}>
            <img src={image} alt={`Gallery item ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery; 